// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"242":"61d0c876","267":"226cf599","339":"a4be2ed7","415":"52901bff"}[chunkId] + ".chunk.css";
};